import * as React from 'react';
import { SVGProps } from 'react';

const IconAllDoneSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#SvgIconAllDone_size_xs__a)">
      <path d="m3.434 4.955-.606.606L6.364 9.6l5.657-6.16-.707-.708-4.95 5.448-2.93-3.225zM.673 4.888 0 5.56 3.535 9.6l.714-.772-3.576-3.94z" />
      <path d="m6.293 6.614 3.324-3.599-.708-.707-3.42 3.421.804.885z" />
    </g>
    <defs>
      <clipPath id="SvgIconAllDone_size_xs__a">
        <path d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default IconAllDoneSizeXs;
